/**
 * Twinkle Cart — package accessory line sync
 * @module cart-addons
 * Keeps _package addon lines in sync with parent line item properties.
 */
(function () {
  const syncPackageAddons = async function (details) {
    const update_addons = {};
    const add_addons = [];
    let qty = 0;
    const cartDrawer = TwinkleCart.getDrawer();
    const items = details?.items;
    if (!items || items.length === 0) return;

    const parentHandles = new Set(
      items.filter((item) => !item.properties?._package).map((item) => item.handle)
    );

    const orphanAddonUpdates = {};
    for (const item of items) {
      const packageHandle = item.properties?._package;
      if (packageHandle && !parentHandles.has(packageHandle)) {
        orphanAddonUpdates[item.key] = 0;
      }
    }

    if (Object.keys(orphanAddonUpdates).length > 0 && cartDrawer) {
      const payload = {
        updates: orphanAddonUpdates,
        ...TwinkleCart.getDrawerSectionPayload(),
      };
      const response = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .catch((err) => console.error('TwinkleCart.addons: orphan cleanup failed', err));

      if (response) TwinkleCart.renderDrawerResponse(response);
      return;
    }

    const temp = {};
    for (const item of items) {
      if (!item.properties) continue;

      const handle = item.handle;
      const addon_package_handle = item.properties['_package'];

      if (addon_package_handle) {
        update_addons[item.key] = 0;
      }

      const addon_configs = Object.keys(item.properties).filter((key) => key.startsWith('_pdp_addon'));
      if (addon_configs.length > 0) {
        if (!temp[handle]) temp[handle] = {};

        for (const addon_config of addon_configs) {
          const propValue = item.properties[addon_config];
          if (propValue && propValue.includes(':')) {
            const [id, qtyRaw] = propValue.split(':');
            const qtyPerBundle = parseInt(qtyRaw, 10) || 0;
            if (qtyPerBundle > 0) {
              const totalNeeded = qtyPerBundle * item.quantity;
              temp[handle][id] = (temp[handle][id] || 0) + totalNeeded;
            }
          }
        }
      }

      if (
        !item.properties._package &&
        addon_configs.length === 0 &&
        item.properties.Accessories &&
        typeof item.properties.Accessories === 'object'
      ) {
        if (!temp[handle]) temp[handle] = {};

        for (const addonItem of items) {
          if (addonItem.properties?._package !== handle) continue;
          const bundleQty = parseInt(item.properties.Accessories[addonItem.handle], 10) || 0;
          if (bundleQty <= 0) continue;
          const totalNeeded = bundleQty * (item.quantity || 1);
          const variantId = String(addonItem.variant_id);
          temp[handle][variantId] = Math.max(temp[handle][variantId] || 0, totalNeeded);
        }
      }
    }

    for (const handle in temp) {
      const built_json = temp[handle];
      for (const item of items) {
        const prop = item.properties['_package'];
        const variant_id = JSON.stringify(item.variant_id);
        if (Object.keys(built_json).includes(variant_id) && prop === handle) {
          qty = built_json[variant_id];
          update_addons[item.key] = qty;
          delete built_json[variant_id];
        }
      }
      if (Object.keys(built_json).length > 0) {
        for (const variantId of Object.keys(built_json)) {
          qty = built_json[variantId];
          if (qty > 0) {
            add_addons.push({
              id: parseInt(variantId, 10),
              quantity: qty,
              properties: { _package: handle },
            });
          }
        }
      }
    }

    let updateResponse = null;

    if (add_addons.length > 0) {
      updateResponse = await fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: add_addons,
          ...TwinkleCart.getDrawerSectionPayload(),
        }),
      })
        .then((res) => res.json())
        .catch((err) => console.error('TwinkleCart.addons: add addons failed', err));
    }

    if (Object.keys(update_addons).length > 0) {
      updateResponse = await fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          updates: update_addons,
          ...TwinkleCart.getDrawerSectionPayload(),
        }),
      })
        .then((res) => res.json())
        .catch((err) => console.error('TwinkleCart.addons: update addons failed', err));
    }

    if (updateResponse) TwinkleCart.renderDrawerResponse(updateResponse);
  };

  document.addEventListener('cart:update', async (event) => {
    await syncPackageAddons(event.detail.cart);
    TwinkleCart.afterCartUpdate();
  });

  TwinkleCart.syncPackageAddons = syncPackageAddons;
})();
